import { g as E } from "./_commonjsHelpers-B52_cu2H.js";
import { i as T, j as x, k as N, l as j } from "./_baseIsEqual-BUJ1vMU3.js";
import { e as m, f as F } from "./set-BNuXIoqy.js";
var v, A;
function H() {
  if (A) return v;
  A = 1;
  function r(e, n, f) {
    for (var t = -1, h = e == null ? 0 : e.length; ++t < h; )
      if (f(n, e[t]))
        return !0;
    return !1;
  }
  return v = r, v;
}
var I, b;
function Y() {
  if (b) return I;
  b = 1;
  var r = T(), e = m(), n = x(), f = 1 / 0, t = r && 1 / n(new r([, -0]))[1] == f ? function(h) {
    return new r(h);
  } : e;
  return I = t, I;
}
var S, p;
function k() {
  if (p) return S;
  p = 1;
  var r = N(), e = F(), n = H(), f = j(), t = Y(), h = x(), y = 200;
  function C(l, q, c) {
    var g = -1, o = e, R = l.length, _ = !0, s = [], i = s;
    if (c)
      _ = !1, o = n;
    else if (R >= y) {
      var U = q ? null : t(l);
      if (U)
        return h(U);
      _ = !1, o = f, i = new r();
    } else
      i = q ? [] : s;
    r:
      for (; ++g < R; ) {
        var u = l[g], a = q ? q(u) : u;
        if (u = c || u !== 0 ? u : 0, _ && a === a) {
          for (var w = i.length; w--; )
            if (i[w] === a)
              continue r;
          q && i.push(a), s.push(u);
        } else o(i, a, c) || (i !== s && i.push(a), s.push(u));
      }
    return s;
  }
  return S = C, S;
}
var d, W;
function D() {
  if (W) return d;
  W = 1;
  var r = k();
  function e(n) {
    return n && n.length ? r(n) : [];
  }
  return d = e, d;
}
var G = D();
const B = /* @__PURE__ */ E(G);
export {
  B as u
};
